class WeekdaysController {
  /* @ngInject */
  constructor ($scope, $state, $attrs) {
    this.$onInit = function () {
      this.days = this.days
    }
  }
}

export default WeekdaysController
